// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"11831218","787":"b4b92a34"}[chunkId] + ".chunk.js";
};